// extracted by mini-css-extract-plugin
export default {"section":"FormSenderAddress_section__8E6Yz"};